import React from 'react';

export interface PreviewSection {
  title: string;
  rows: { label: string; value?: React.ReactNode }[];
}

// Read-only label/value summary of a form, shown before the user confirms it. Blank values show as a dash.
const PreviewDetails = ({ sections }: { sections: PreviewSection[] }) => (
  <div className="space-y-4">
    {sections.map((section) => (
      <section key={section.title}>
        <h4 className="mb-2 text-sm font-semibold text-gray-200">{section.title}</h4>
        <dl className="m-0 rounded-lg border border-gray-700 divide-y divide-gray-700">
          {section.rows.map((row) => (
            <div key={row.label} className="flex justify-between gap-6 px-3 py-2 text-sm">
              <dt className="flex-shrink-0 text-gray-400">{row.label}</dt>
              <dd className="m-0 min-w-0 break-words text-right text-white">{row.value || row.value === 0 ? row.value : '—'}</dd>
            </div>
          ))}
        </dl>
      </section>
    ))}
  </div>
);

export default PreviewDetails;
